import type { OwnCashier, OwnCashierProfile } from './types'

/** Ввод формы карточки: строки как набраны. */
export interface OwnCashierProfileInput { lastName: string; firstName: string; middleName: string; position: string }

export const emptyProfileInput: OwnCashierProfileInput = { lastName: '', firstName: '', middleName: '', position: '' }

/** Ввод формы из карточки. У записи прежнего редактора связей ФИО пусто: администратор заполняет его, глядя на отображаемое имя в заголовке. */
export function profileInputOf(cashier: OwnCashier): OwnCashierProfileInput {
  return { lastName: cashier.lastName ?? '', firstName: cashier.firstName ?? '', middleName: cashier.middleName ?? '', position: cashier.position ?? '' }
}

const squeeze = (value: string) => value.trim().split(/\s+/).filter((part) => part !== '').join(' ')

/** ФИО и должность к отправке: пробелы сжаты, пустые отчество и должность — `null`. Длины и правила окончательно проверяет сервер. */
export function profileOf(input: OwnCashierProfileInput): OwnCashierProfile {
  const middleName = squeeze(input.middleName); const position = squeeze(input.position)
  return { lastName: squeeze(input.lastName), firstName: squeeze(input.firstName), middleName: middleName === '' ? null : middleName, position: position === '' ? null : position }
}

/** Что мешает сохранить ФИО — словами экрана; `null` — можно отправлять. */
export function profileProblem(input: OwnCashierProfileInput): string | null {
  const profile = profileOf(input)
  return profile.lastName === '' || profile.firstName === '' ? 'Укажите фамилию и имя кассира.' : null
}

/**
 * Что мешает задать код — словами экрана; `null` — можно отправлять. Здесь только длина, знаки и повтор: правила длины приходят с сервера,
 * простые и занятые коды отклоняет сервер своим текстом.
 */
export function codeProblem(code: string, repeat: string, minLength: number, maxLength: number): string | null {
  if (code.length < minLength || code.length > maxLength) return `Код — от ${minLength} до ${maxLength} знаков.`
  if (!/^[A-Za-z0-9]+$/.test(code)) return 'Код — только латинские буквы и цифры (подходит штрихкод бейджа).'
  if (code !== repeat) return 'Код и повтор не совпадают.'
  return null
}

/** Совпадает ли имя кассира источника с фамилией кассира: только подсказка, связь ставит человек. */
export function sameSurname(name: string, cashier: OwnCashier): boolean {
  const surname = (cashier.lastName ?? cashier.displayName.split(' ')[0] ?? '').toLocaleLowerCase('ru-RU')
  return surname !== '' && name.toLocaleLowerCase('ru-RU').includes(surname)
}
